import { MosaicTocSectionClass } from "./MosaicTocSectionClass";
import type { IMosaicTocExpanded, ITocActionMoveItem } from "./interface";

/**
 * Moves a ToC item to a new position and normalises item ordering.
 *
 * @param state - The current expanded ToC state.
 * @param action - The action describing the move.
 * @returns The updated ToC state after reordering items.
 */
export const toc_moveItem = (
  state: IMosaicTocExpanded,
  action: ITocActionMoveItem,
): IMosaicTocExpanded => {
  const newState: IMosaicTocExpanded = { ...state };
  const moveIndex = newState.tocItems.map((item) => item.id).indexOf(action.itemId);

  if (moveIndex < 0) {
    return newState;
  }

  /* istanbul ignore else */
  if (moveIndex !== action.newIndex) {
    newState.tocItems.splice(action.newIndex, 0, newState.tocItems.splice(moveIndex, 1)[0]);
    newState.tocItems.forEach((item, index) => {
      if (item.tocOrder !== index) {
        if (item instanceof MosaicTocSectionClass) {
          item.update({ id: item.id, saved: false, tocOrder: index });
        } else {
          item.tocOrder = index;
          item.changed = true;
          item.inError = false;
        }
      }
    });
  }
  newState.saving = true;

  return newState;
};
